module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#tag",
      toString: function () {
        return this.url;
      }
    }